import { ChevronDown } from "lucide-react";
import { type ReactNode, useState } from "react";

export interface DisclosureProps {
  icon?: ReactNode;
  label: ReactNode;
  children: ReactNode;

  defaultOpen?: boolean;
}

export function Disclosure({ icon, label, children, defaultOpen = false }: Readonly<DisclosureProps>) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div>
      <button
        type="button"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((open) => !open)}
        className="inline-flex cursor-pointer items-center gap-1 text-xs text-content-tertiary transition-colors hover:text-content-secondary"
      >
        {icon}
        <span className="font-medium">{label}</span>
        <ChevronDown size={12} className={["shrink-0 transition-transform", isOpen ? "rotate-180" : ""].join(" ")} />
      </button>
      {isOpen && (
        <div className="mt-2 overflow-hidden rounded-xl border border-border-subtle bg-surface-elevated">
          {children}
        </div>
      )}
    </div>
  );
}
